import { usePunditUserContext } from "@circle-react/contexts";
import { useEmailHubStatus } from "@circle-react/contexts/EmailHubStatusContext";

export const useMarketingHubAccessEndDate = () => {
  const { data, isLoading: isLoadingEmailHubStatus } = useEmailHubStatus();
  const { currentCommunity } = usePunditUserContext();

  if (!data || !("plan" in data) || isLoadingEmailHubStatus) {
    return {
      isLoading: isLoadingEmailHubStatus,
      accessEndDate: null,
    };
  }

  const { enabled: isEmailHubStatusEnabled, trialing: isTrialing, plan } = data;

  if (!isEmailHubStatusEnabled)
    return {
      isLoading: isLoadingEmailHubStatus,
      accessEndDate: null,
    };

  if (isTrialing)
    return {
      isLoading: isLoadingEmailHubStatus,
      accessEndDate: currentCommunity?.trial_ends_at ?? null,
    };

  if (plan.cancel_at_period_end && plan.current_period_end)
    return {
      isLoading: isLoadingEmailHubStatus,
      accessEndDate: plan.current_period_end,
    };

  return {
    isLoading: isLoadingEmailHubStatus,
    accessEndDate: null,
  };
};
